module.exports = __webpack_public_path__ + "static/media/icon_warning.db443e14.svg";